import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './component/Home';
import About from './component/About';
import DasarHukum from './component/DasarHukum';
import StrukturOrganisasi from './component/StrukturOganisasi';
import AnggotaJdih from './component/AnggotaJdih';
import DetailProdukHukum from './component/DetailProdukHukum';
import DetailProdukHukumTerkait from './component/DetailProdukHukumTerkait';
import HalamanPencarian from './component/HalamanPencarian';
import SopJdih from './component/SopJdih';
import Contact from './component/Contact';
import Footer from './component/Footer';
import BtnMsg from './component/BtnMsg';
import Blog from './component/Blog';
import Pengumuman from './component/Pengumuman';
import PengumumanDetail from './component/PengumumanDetail';
import AgendaList from './component/AgendaList';
import GalleryList from './component/GalleryList';
import GalleryVideoList from './component/GalleryVideoList';
import DetailBlog from './component/DetailBlog';
import AgendaDetail from './component/AgendaDetail';
import EbookDetail from './component/EbookDetail';
import GuestBook from './component/GuestBook';
import StrukturJdih from './component/StrukturJdih';
import DataStatistik from './component/DataStatistik';
import News from './component/News';
import { Provider } from 'react-redux';
import store from './redux/store';


function App() {
  return (
    <Router>
      <Provider store={store}>
        <div className="max-w-12xl mx-auto">
          <main className="p-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/homefo" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/dasar-hukum" element={<DasarHukum />} />
              <Route path="/berita/:id" element={<Blog />} />
              <Route path="/berita" element={<News />} />
              <Route path="/agenda" element={<AgendaList />} />
              <Route path="/galeri" element={<GalleryList />} />
              <Route path="/galeri-video" element={<GalleryVideoList />} />
              <Route path="/pengumuman" element={<Pengumuman />} />
              <Route path="/detail-pengumuman/:id/:slug" element={<PengumumanDetail />} />
              <Route path="/struktur-organisasi" element={<StrukturOrganisasi />} />
              <Route path="/struktur-organisasi-jdih" element={<StrukturJdih />} />
              <Route path="/sop-jdih" element={<SopJdih />} />
              <Route path="/anggota-jdih" element={<AnggotaJdih />} />
              <Route path="/detail-produk-hukum/:id" element={<DetailProdukHukum />} />
              <Route path="/detail-produk-hukum-terkait/:id" element={<DetailProdukHukumTerkait />} />
              <Route path="/pencarian-produk-hukum/:id" element={<HalamanPencarian />} />
              <Route path="/detail-berita/:id/:slug" element={<DetailBlog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/detail-agenda/:id/:slug" element={<AgendaDetail />} />
              <Route path="/detail-ebook/:id/:slug" element={<EbookDetail />} />
              <Route path="/guest-book" element={<GuestBook />} />
              <Route path="/data-statistik" element={<DataStatistik />} />
            </Routes>
          </main>
          {/*<BtnMsg />*/}
        </div>
        <Footer />
      </Provider>
    </Router>
  );
}

export default App;
